import axios from "axios";
import { API_URL } from "../constant";

const API = axios.create({
  baseURL: API_URL,
  headers: {
    "x-api-key": "87ca3be51267e060867f385607f7112dd907f5cea57992e32ad15744da882774", 
  },
});

// Optional: add interceptors (e.g. add tokens dynamically)
API.interceptors.request.use((config) => {
  return config;
});

export default API;